const FIREBASE_AUTH_NETWORK_REQUEST_FAILED = "auth/network-request-failed";
const BROWSER_BRIDGE_OBJECT_NOT_FOUND = "Object Not Found Matching Id:";
const BROWSER_BRIDGE_UPDATE_METHOD = "MethodName:update";
const BROWSER_BRIDGE_PARAM_COUNT = "ParamCount:";

type SentryExceptionValue = {
  type?: unknown;
  value?: unknown;
};

type SentryLikeEvent = {
  message?: unknown;
  exception?: {
    values?: SentryExceptionValue[];
  };
};

type Breadcrumb = {
  category: string;
  message: string;
  level: "warning";
  data: {
    reason: string;
  };
};

const collectEventErrorValues = (event: SentryLikeEvent) => {
  const values: string[] = [];

  if (typeof event.message === "string") {
    values.push(event.message);
  }

  for (const exception of event.exception?.values ?? []) {
    if (typeof exception.type === "string") values.push(exception.type);
    if (typeof exception.value === "string") values.push(exception.value);
  }

  return values;
};

export const getFirebaseAuthNetworkRequestFailedValue = (
  event: SentryLikeEvent,
) =>
  collectEventErrorValues(event).find((value) =>
    value.includes(FIREBASE_AUTH_NETWORK_REQUEST_FAILED),
  );

export const isFirebaseAuthNetworkRequestFailedEvent = (
  event: SentryLikeEvent,
) => getFirebaseAuthNetworkRequestFailedValue(event) !== undefined;

export const getFirebaseAuthNetworkRequestFailedBreadcrumb = (
  event: SentryLikeEvent,
): Breadcrumb | null => {
  const reason = getFirebaseAuthNetworkRequestFailedValue(event);

  if (!reason) {
    return null;
  }

  return {
    category: "auth",
    message: "firebase-auth-network-request-failed",
    level: "warning",
    data: {
      reason,
    },
  };
};

export const getBrowserBridgeObjectNotFoundValue = (event: SentryLikeEvent) =>
  collectEventErrorValues(event).find(
    (value) =>
      value.includes(BROWSER_BRIDGE_OBJECT_NOT_FOUND) &&
      value.includes(BROWSER_BRIDGE_UPDATE_METHOD) &&
      value.includes(BROWSER_BRIDGE_PARAM_COUNT),
  );

export const isBrowserBridgeObjectNotFoundEvent = (event: SentryLikeEvent) =>
  getBrowserBridgeObjectNotFoundValue(event) !== undefined;

export const getBrowserBridgeObjectNotFoundBreadcrumb = (
  event: SentryLikeEvent,
): Breadcrumb | null => {
  const reason = getBrowserBridgeObjectNotFoundValue(event);

  if (!reason) {
    return null;
  }

  return {
    category: "browser",
    message: "browser-bridge-object-not-found",
    level: "warning",
    data: {
      reason,
    },
  };
};

export const getSuppressedNoiseEventBreadcrumb = (
  event: SentryLikeEvent,
): Breadcrumb | null =>
  getFirebaseAuthNetworkRequestFailedBreadcrumb(event) ??
  getBrowserBridgeObjectNotFoundBreadcrumb(event);
